<template>
    <b-row>
        <b-col md="12">
            <b-card>
                <b-form v-on:submit.prevent enctype="multipart/form-data">
                    <b-row class="mb-3 mt-5">
                        <b-col md="12" class="d-flex">
                            <img src="../../../../public/logo-esa.png" width="50px" height="50px">
                            <h2 class="ml-1 mb-0 d-flex align-items-center">PT Gracia Teknologi Inovasi</h2>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6" class="text-left mb-2"></b-col>
                        <b-col md="6" class="text-left mb-2">
                            <span class="font-weight-bold h1 text-primary">INVOICE</span>
                        </b-col>
                    </b-row>
                    <b-row class="mb-5">
                        <b-col md="6" style="margin-bottom: 10px;">
                            <b-row>
                                <b-col md="4">
                                    <label class="h6 w-100">Purchase Code <span class="float-right">:</span></label>
                                </b-col>
                                <b-col md="8">
                                    <span class="text-primary font-weight-bold">{{ form.code }}</span>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="4">
                                    <label class="h6 w-100">Date <span class="float-right">:</span></label>
                                </b-col>
                                <b-col md="8">
                                    <span class="text-primary font-weight-bold">{{ moment(form.date) }}</span>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col md="6" style="margin-bottom: 10px;">
                            <b-row>
                                <b-col md="4">
                                    <label class="h6 w-100">Vendor <span class="float-right">:</span></label>
                                </b-col>
                                <b-col md="8">
                                    <span class="text-primary font-weight-bold">{{ form.vendor }}</span>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="4">
                                    <label class="h6 w-100">Shipping Address <span class="float-right">:</span></label>
                                </b-col>
                                <b-col md="8">
                                    <span class="text-primary font-weight-bold">{{ form.shipping_address }}</span>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="4">
                                    <label class="h6 w-100">Shipping Date <span class="float-right">:</span></label>
                                </b-col>
                                <b-col md="8">
                                    <span class="text-primary font-weight-bold">{{ moment(form.shipping_date) }}</span>
                                </b-col>
                            </b-row>
                            <b-row v-if="form.is_warehouse === 1">
                                <b-col md="4">
                                    <label class="h6 w-100">Warehouse <span class="float-right">:</span></label>
                                </b-col>
                                <b-col md="8">
                                    <span class="text-primary font-weight-bold">{{ form.warehouse_name }}</span>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="4">
                                    <label class="h6 w-100">Note <span class="float-right">:</span></label>
                                </b-col>
                                <b-col md="8">
                                    <span class="text-primary font-weight-bold">{{ form.description }}</span>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100">Name</label>
                        </b-col>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100">Qty</label>
                        </b-col>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100">Unit</label>
                        </b-col>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100">Price</label>
                        </b-col>
                    </b-row>
                    <hr style="border: 2px solid black;">
                    <b-row class="mb-0" v-for="(row, index) in rows" :key="index">
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100">{{ row.name }}</label>
                        </b-col>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100">{{ row.qty }}</label>
                        </b-col>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100">{{ row.unit_name }}</label>
                        </b-col>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100">{{ formatRupiah(row.price) }}</label>
                        </b-col>
                        <b-col md="12">
                            <hr style="border: 1px solid lightgrey;">
                        </b-col>
                    </b-row>
                    <b-row class="mb-0">
                        <b-col cols="6" md="6" class="text-center">
                        </b-col>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100 text-primary font-weight-bold">Subtotal <span class="float-right">:</span></label>
                        </b-col>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100 text-primary font-weight-bold">{{ formatRupiah(form.subtotal) }}</label>
                        </b-col>
                        <b-col cols="6" md="6" class="text-center">
                        </b-col>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100">Tax <span class="float-right">:</span></label>
                        </b-col>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100">{{ formatRupiah(form.tax) }}</label>
                        </b-col>
                        <b-col cols="6" md="6" class="text-center">
                        </b-col>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100">Additional Cost <span class="float-right">:</span></label>
                        </b-col>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100">{{ formatRupiah(form.additional_cost) }}</label>
                        </b-col>
                        <b-col md="6">
                        </b-col>
                        <b-col md="6">
                            <hr style="border: 1px solid lightgrey;">
                        </b-col>
                    </b-row>
                    <b-row class="mb-5">
                        <b-col cols="6" md="6" class="text-left">
                            <b-row>
                                <b-col md="4">
                                    <label class="h6 w-100">Term Payment <span class="float-right">:</span></label>
                                </b-col>
                                <b-col md="8">
                                    <span class="text-primary font-weight-bold">{{ form.term_payment }}</span>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100 text-success font-weight-bold">Total Price<span class="float-right">:</span></label>
                        </b-col>
                        <b-col cols="3" md="3" class="text-center">
                            <label class="h6 w-100 text-success font-weight-bold">{{ formatRupiah(form.total_price) }}</label>
                        </b-col>
                        <b-col md="6">
                        </b-col>
                        <b-col md="6">
                            <hr style="border: 1px solid lightgrey;">
                        </b-col>
                    </b-row>
                </b-form>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import {
    BCard, BCardText, BRow, BCol, BForm,
} from 'bootstrap-vue'
import { $themeConfig } from "@themeConfig"
import moment from 'moment'

export default {
    components: {
        BCard,
        BCardText,
        BRow,
        BCol,
        BForm,
    },
    data() {
        return {
            form: {
                code: '',
                date: null,
                vendor: '',
                shipping_address: '',
                shipping_date: '',
                is_warehouse: null,
                warehouse_name: '',
                description: '',
                term_payment: '',
                tax: null,
                additional_cost: null,
                total_price: null,
                subtotal: 0,
            },
            permissions: [],
            rows: [],
            errors: '',
            errMessage: ''
        }
    },
    setup() {
        // App Name
        const { baseUrl, apiUrl } = $themeConfig.app;
        return {
            baseUrl,
            apiUrl
        };
    },
    created() {
        this.getAllPermissions()
        this.getDetails()
        this.getPurchaseItems()
    },
    methods: {
        formatRupiah(money) {
            return new Intl.NumberFormat('id-ID',
                { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }
            ).format(money);
        },
        moment(date) {
            return moment(date).format('DD-MM-YYYY');
        },
        getAllPermissions() {
            this.permissions = sessionStorage.getItem('permissions')
        },
        getDetails() {
            const id = this.$route.params.id
            this.$http.get('procurement/purchase/'+id)
            .then(response => { 
                // console.log(response.data.data)
                this.form.defaultTotalPrice = response.data.data.total_price - response.data.data.tax - response.data.data.additional_cost
                this.form.code = response.data.data.code
                this.form.date = response.data.data.date
                this.form.vendor = response.data.data.vendor_name
                this.form.shipping_address = response.data.data.shipping_address
                this.form.shipping_date = response.data.data.shipping_date
                this.form.is_warehouse = response.data.data.is_warehouse
                this.form.warehouse_name = response.data.data.warehouse_name
                this.form.description = response.data.data.description
                this.form.term_payment = response.data.data.term_payment_name
                this.form.tax = response.data.data.tax
                this.form.additional_cost = response.data.data.additional_cost
                this.form.total_price = response.data.data.total_price
            });
        },
        getPurchaseItems() {
            const id = this.$route.params.id
            this.$http.get('procurement/purchases/'+id+'/items')
            .then(response => { 
                // console.log(response.data.data)
                var datas = response.data.data
                var i
                const { baseUrl } = $themeConfig.app
                for(i=0; i<datas.length; i++) {
                    this.photo = baseUrl
                    this.photo += 'storage/product/'
                    this.photo += datas[i].product_image
                    // console.log(this.photo)
                    var $data = {
                        value: datas[i].id,
                        image: this.photo,
                        code: datas[i].purchase_code,
                        name: datas[i].product_name,
                        qty: datas[i].qty,
                        unit_name: datas[i].unit_name,
                        price: datas[i].price
                    }
                    // console.log($data)
                    this.form.subtotal += datas[i].price
                    this.rows.push($data)
                }
                // console.log(this.form.subtotal)
            });
        },
    },
}
</script>